import React, { createContext, useMemo } from 'react';
export var FulfillmentGroupContext = createContext(undefined);
export function FulfillmentGroupProvider(_a) {
    var children = _a.children, fulfillmentGroup = _a.fulfillmentGroup, fulfillmentType = _a.fulfillmentType, fulfillmentGroupIndex = _a.fulfillmentGroupIndex;
    var value = useMemo(function () {
        return {
            fulfillmentGroup: fulfillmentGroup,
            fulfillmentGroupIndex: fulfillmentGroupIndex,
            fulfillmentType: fulfillmentType,
        };
    }, [fulfillmentGroup, fulfillmentType, fulfillmentGroupIndex]);
    return (React.createElement(FulfillmentGroupContext.Provider, { value: value }, children));
}
